"use client";

import { TranslationData, VariantItemPdp } from "@/common/lib/types";
import { cn } from "@/lib/tailwind";
import { IPowerList } from "@/utils/product.utils";
import { useMemo } from "react";
import TabsV2 from "../../ui/tabs/TabsV2";
import PowerSelection from "./PowerSelection";
import QuantitySelector from "./QuantitySelector";
import { usePdpContext } from "@/providers/PdpProvider";

interface IProps {
  classname?: string;
  isClLens: boolean;
  translations: TranslationData;
  powerList: Record<string, IPowerList[]>;
  selectedColor: string;
  selectedPack?: string;
  selectedVariant: VariantItemPdp | undefined;
  secondarySelectedVariant: VariantItemPdp | undefined;
  handleVariantSelection: (id: string) => void;
  handleSecondaryVariantSelection: (id: string) => void;
  powerSelectionProps: {
    hasPowerSelectionError: boolean;
    hasPowerSelected: boolean;
    handlePowerSelectionStatus: (isSelected: boolean) => void;
  };
  quantitySelectorProps: {
    handleQuantityChange: (quantity: number, isSecondaryVariant: boolean) => void;
    quantity: number;
    secondaryVariantQuantity: number;
  };
  handleResetPowerSelectionError: () => void;
}

const LensPowerSelection = ({
  isClLens,
  translations,
  powerList,
  selectedColor,
  classname,
  selectedPack,
  handleVariantSelection,
  handleSecondaryVariantSelection,
  powerSelectionProps,
  quantitySelectorProps,
  handleResetPowerSelectionError,
  secondarySelectedVariant,
  selectedVariant,
}: IProps) => {
  // getting the zero power lens from lens list
  const noPowerLens = useMemo(() => {
    return powerList[selectedColor]?.find((v) => v.power === "0.00");
  }, [selectedColor]);

  const lensInfo = noPowerLens ?? powerList[selectedColor]?.[0];

  const { lensSelectionTabIndex, setLensSelectionTabIndex } = usePdpContext();

  const handleTabChange = (idx: number) => {
    setLensSelectionTabIndex(idx);
    quantitySelectorProps.handleQuantityChange(1, false);
    // powerSelectionProps.handlePowerSelectionStatus(true);
  };

  // useEffect(() => {
  //   let currTab = 0;

  //   if (noPowerLens && noPowerLens?.id !== selectedVariant?.id) {
  //     currTab = 1;
  //   }

  //   setLensSelectionTabIndex(currTab);
  // }, []);

  // useEffect(() => {
  // if (!noPowerLens && lensSelectionTabIndex === 0 && isClLens) {
  //   setIsOutOfStock(true);
  // } else {
  // setIsOutOfStock(
  //   selectedVariant?.quantityAvailable! <= 0 || secondarySelectedVariant?.quantityAvailable! <= 0,
  // );
  // }
  // }, [lensSelectionTabIndex, noPowerLens, selectedVariant, secondarySelectedVariant]);

  // useEffect(() => {
  //   if (lensSelectionTabIndex === 0 && isClLens && noPowerLens) {
  //     // handleVariantSelection(noPowerLens?.id ?? "");
  //     powerSelectionProps.handlePowerSelectionStatus(true);
  //   } else {
  //   powerSelectionProps.handlePowerSelectionStatus(false);
  //   }
  // }, [lensSelectionTabIndex, isClLens]);

  return (
    <section className={cn("mx-5 my-6 md:mx-0 md:my-0", classname)}>
      {isClLens ? (
        <TabsV2
          index={lensSelectionTabIndex}
          handleTabChange={handleTabChange}
          tabsContainerClass="grid grid-cols-2 lg:grid-cols-3"
          contentContainerClass="w-full xl:w-[33rem] transition-transform ease-in-out"
          options={[
            !noPowerLens
              ? null
              : {
                  title: translations.pdp?.pdp_without_power_label ?? "Without Power",
                  content: (
                    <div className="mt-5 grid grid-cols-2 gap-8 py-6 md:w-[25rem] md:bg-tertiary-5 md:pr-7">
                      <div className="pt-2 text-sm md:pl-6">
                        {translations.pdp?.pdp_no_of_boxes_input_label}
                      </div>

                      <QuantitySelector
                        value={quantitySelectorProps.quantity}
                        max={Math.max(noPowerLens?.quantity ?? 1, 1)}
                        min={1}
                        handleAdd={() =>
                          quantitySelectorProps.handleQuantityChange(
                            ++quantitySelectorProps.quantity,
                            false,
                          )
                        }
                        handleSub={() =>
                          quantitySelectorProps.handleQuantityChange(
                            --quantitySelectorProps.quantity,
                            false,
                          )
                        }
                        selectedPack={selectedPack ?? lensInfo?.clPerPackSize}
                        multipleLabel={
                          translations?.pdp?.pdp_no_of_lens_count_per_box_multiple_label ?? ""
                        }
                        singleLabel={
                          translations?.pdp?.pdp_no_of_lens_count_per_box_single_label ?? ""
                        }
                      />
                    </div>
                  ),
                },
            {
              title: noPowerLens ? (translations?.pdp?.pdp_with_power_label ?? "With Power") : null,
              content: (
                <div className="md:w-[32rem]">
                  <PowerSelection
                    translations={translations}
                    powerList={powerList}
                    selectedColor={selectedColor}
                    handleVariantSelection={handleVariantSelection}
                    handleSecondaryVariantSelection={handleSecondaryVariantSelection}
                    handlePowerSelectionStatus={powerSelectionProps.handlePowerSelectionStatus}
                    hasPowerSelected={powerSelectionProps.hasPowerSelected}
                    hasPowerSelectionError={powerSelectionProps.hasPowerSelectionError}
                    quantitySelectorProps={quantitySelectorProps}
                    handleResetPowerSelectionError={handleResetPowerSelectionError}
                    selectedPack={selectedPack}
                  />
                </div>
              ),
            },
          ]}
        />
      ) : (
        <PowerSelection
          translations={translations}
          powerList={powerList}
          selectedColor={selectedColor}
          handleVariantSelection={handleVariantSelection}
          handleSecondaryVariantSelection={handleSecondaryVariantSelection}
          handlePowerSelectionStatus={powerSelectionProps.handlePowerSelectionStatus}
          hasPowerSelected={powerSelectionProps.hasPowerSelected}
          hasPowerSelectionError={powerSelectionProps.hasPowerSelectionError}
          quantitySelectorProps={quantitySelectorProps}
          handleResetPowerSelectionError={handleResetPowerSelectionError}
          selectedPack={selectedPack}
        />
      )}
    </section>
  );
};

export default LensPowerSelection;
